module.exports = __webpack_public_path__ + "img/mitsu-New.bf26e694.png";